import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { COMPANY, GOOGLE_LISTING } from "@/data/content";
import AnimatedDashboard, { LiveTicker } from "@/components/AnimatedDashboard";

export default function HeroVideo() {
  return (
    <section className="relative isolate overflow-hidden border-b-2 border-black bg-[#FFD700]">
      {/* Animated dashboard background — replaces stock video for guaranteed on-brand visuals */}
      <div className="absolute inset-0 -z-10">
        <AnimatedDashboard />
      </div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-20 md:grid-cols-12 md:px-8 md:py-28 lg:py-36">
        <div className="md:col-span-8 lg:col-span-7">
          <div className="tape-dark fade-up">Leading E-commerce & Marketplace Growth Partner in India</div>
          <h1 className="display fade-up delay-1 mt-6 text-5xl font-black leading-[0.95] tracking-tight md:text-6xl lg:text-7xl">
            E-commerce Marketplace<br />
            <span className="bg-black px-2 text-[#FFD700]">Management &amp; Growth</span><br />
            Services in India.
          </h1>
          <p className="fade-up delay-2 mt-6 max-w-2xl text-base leading-relaxed text-black/85 md:text-lg">
            Launch, manage and scale your brand across India's leading marketplaces and quick-commerce platforms — Amazon, Flipkart, Meesho, JioMart, Myntra, Nykaa, Blinkit, Zepto and more. End-to-end onboarding, listing optimization, A+ graphics, ads, CRM and manpower under one roof.
          </p>

          <div className="fade-up delay-3 mt-8 flex flex-wrap gap-3">
            <Link to="/contact/?type=start" className="btn-brutal" data-testid="hero-cta-start">
              Start Selling <ArrowUpRight size={16} />
            </Link>
            <Link to="/contact/?type=expert" className="btn-brutal secondary" data-testid="hero-cta-expert">
              Talk to an Expert
            </Link>
            <Link to="/contact/?type=audit" className="btn-brutal dark" data-testid="hero-cta-audit">
              Free Account Audit
            </Link>
          </div>

          <div className="fade-up delay-4 mt-10 grid max-w-md grid-cols-3 gap-4">
            {[
              { k: "200+", v: "Brands launched" },
              { k: "10+", v: "Marketplaces" },
              { k: "₹500Cr+", v: "Managed GMV" },
            ].map((s) => (
              <div key={s.k} className="border-l-2 border-black pl-3">
                <div className="display text-2xl font-black md:text-3xl">{s.k}</div>
                <div className="text-xs font-medium text-black/70">{s.v}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden md:col-span-4 md:block lg:col-span-5">
          <div className="relative ml-auto max-w-md space-y-4">
            <LiveTicker />
            <div
              className="block border-2 border-black bg-white px-5 py-4 shadow-brutal-sm transition-shadow hover:shadow-brutal"
              data-testid="hero-google-listing"
            >
              <div className="display text-xl font-black">⭐ {COMPANY.rating}/5</div>
              <div className="text-[10px] font-bold uppercase tracking-widest text-black/70">
                Orina Enterprise on Google · Verified listing
              </div>
              <div className="mt-2 flex flex-wrap gap-2">
                <a
                  href={GOOGLE_LISTING.mapsUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="border border-black bg-[#FFD700] px-2 py-0.5 text-[9px] font-bold uppercase tracking-widest hover:bg-black hover:text-[#FFD700]"
                >View on Google →</a>
                <a
                  href={GOOGLE_LISTING.writeReviewUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="border border-black bg-black px-2 py-0.5 text-[9px] font-bold uppercase tracking-widest text-[#FFD700] hover:bg-[#FFD700] hover:text-black"
                  data-testid="hero-google-review"
                >Write a review</a>
              </div>
            </div>
            <div className="inline-block border-2 border-black bg-[#FFD700] px-4 py-2 text-xs font-bold uppercase tracking-widest shadow-brutal-sm">
              Live in 7 days · Amazon SPN · JioMart Verified
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
